import React from 'react';
import { motion } from 'framer-motion';
import { FaGithub } from 'react-icons/fa';

const fadeUp = {
  hidden: { opacity: 0, y: 40 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, delay: i * 0.15, ease: [0.25, 0.46, 0.45, 0.94] }
  })
};

const Projects = () => {
  return (
    <section id="projects" className="section-wrapper">
      <motion.div
        className="section-header"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: false, margin: "-80px" }}
        variants={fadeUp}
        custom={0}
      >
        <span className="section-label">Portfolio</span>
        <h2 className="section-title">
          Featured <span className="gradient-text">Project</span>
        </h2>
        <p className="section-subtitle">
          A real-world application I designed and developed as my final year diploma project.
        </p>
      </motion.div>

      <motion.div
        className="glass project-card"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: false, margin: "-80px" }}
        variants={fadeUp}
        custom={1}
      >
        {/* Project Thumbnail */}
        <div className="project-image" style={{ height: '320px', padding: 0, overflow: 'hidden' }}>
          <img
            src={process.env.PUBLIC_URL + '/library-thumbnail.png'}
            alt="GPT Kampli Library Management System"
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              objectPosition: 'top center',
            }}
          />
        </div>

        {/* Content */}
        <div className="project-body">
          <h3 className="project-title">GPT Kampli Library System</h3>
          <p className="project-desc">
            A comprehensive full-stack library management solution built as my final year diploma project.
            Designed for GPT Kampli to handle book inventories, student borrowing workflows,
            automated fine calculations, and administrative oversight with a modern, responsive interface.
          </p>

          <div className="project-tags">
            {['React', 'Node.js', 'Database', 'REST API', 'Authentication', 'Dashboard'].map((tag, i) => (
              <span key={i} className="project-tag">{tag}</span>
            ))}
          </div>

          <div className="project-links">
            <a
              href="https://github.com/kotresh75/GPT-Kampli-Library-Management-System"
              target="_blank"
              rel="noreferrer"
              className="btn btn-primary"
            >
              <FaGithub size={18} />
              View on GitHub
            </a>
          </div>
        </div>
      </motion.div>
    </section>
  );
};

export default Projects;
